import {useWhiteLabelDm} from "../../../../../__snowpack__/link/packages/old-dm/dist/dm.esm.js";
import {useTranslation} from "../../../../../__snowpack__/link/packages/old-i18n/dist/i18n.esm.js";
import {useCallback, useEffect, useState} from "react";
import {execFn} from "../../../../common/generic-react.functions.js";
import {useStateWithCallbackLazy} from "../../../../hooks/state-with-callback.hook.js";
import {useReduxWhiteLabelConfig, useReduxWhiteLabelTheme} from "../../../../redux/white-label/white-label.hooks.js";
export function useWhiteLabelItemGenerator({
  jwt,
  id,
  onChange
}) {
  const {
    t
  } = useTranslation();
  const [customTheme, setCustomTheme, resetTheme] = useReduxWhiteLabelTheme();
  const [customConfig, setConfig, resetConfig] = useReduxWhiteLabelConfig();
  const [item, setItem] = useStateWithCallbackLazy(void 0);
  const [title, setTitle] = useState(t("whiteLabel.content.titleAdd"));
  const [wltitle, setWLTitle] = useState(t("whiteLabel.content.wltitleAdd"));
  const {
    getClientInstance
  } = useWhiteLabelDm(jwt);
  const setCustomConfig = useCallback((config) => {
    if (!config) {
      return;
    }
    setConfig({
      name: config?.name,
      white_label: config?.white_label
    });
  }, [setConfig]);
  useEffect(() => {
    if (id) {
      setTitle(t("whiteLabel.content.titleEdit"));
      setWLTitle(t("whiteLabel.content.wltitleEdit"));
      getClientInstance(id).then((result) => {
        setItem(result, (res) => {
          execFn(onChange, res);
          setCustomConfig(res);
        });
      });
    }
  }, [getClientInstance, id, onChange, setItem, setCustomTheme, t, setCustomConfig]);
  return {
    item,
    title,
    wltitle,
    customTheme: [customTheme, setCustomTheme, resetTheme],
    customConfig: [customConfig, setCustomConfig, resetConfig]
  };
}
